<template>
  <div>
    <q-dialog :visible="isVisible" :title="title" width="550px" :innerScroll="false" :showFooter="false" @close="onCancel">
      <div v-loading="loading" element-loading-text="数据加载中" element-loading-spinner="el-icon-loading">
        <el-form :model="requestParam" :rules="rules" ref="requestParam" label-position="top">
          <el-row>
            <el-col :span="24" align="left">
              <el-form-item label="商户号全部交易账单导入">
                <el-upload
                  class="upload-demo"
                  accept=".xls,.xlsx"
                  ref="upload"
                  :limit="1"
                  action=""
                  :disabled="disabled"
                  :http-request="httpRequest"
                  :on-remove="handleRemove"
                  :headers="headers"
                  :file-list="fileList"
                  :on-success="handleSuccess"
                  :before-upload="beforeUpload"
                >
                  <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
                  <div slot="tip" class="el-upload__tip">只能上传xls、xlsx文件，且大小不能超过10MB</div>
                </el-upload>
              </el-form-item>
            </el-col>
            <el-col :span="24" align="left">
              <el-form-item label="商户号流水账单导入(X年X月之前请导入基本账户账单其他时问导入运营账户账单)">
                <el-upload
                  class="upload-demo"
                  accept=".xls,.xlsx"
                  ref="upload"
                  :limit="1"
                  action=""
                  :disabled="disabled"
                  :http-request="httpRequest"
                  :on-remove="handleRemove2"
                  :headers="headers"
                  :file-list="fileList2"
                  :on-success="handleSuccess"
                  :before-upload="beforeUpload2"
                >
                  <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
                  <div slot="tip" class="el-upload__tip">只能上传xls、xlsx文件，且大小不能超过10MB</div>
                </el-upload>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div style="text-align: center">
          <el-button @click="onCancel" size="medium">关 闭</el-button>
          <el-button @click="checkFormValid" type="primary" size="medium">导 入</el-button>
        </div>
      </div>
    </q-dialog>
  </div>
</template>

<script>
import moment from "moment";
import { getToken } from "@/utils/auth";
import {SUB_APP_CODE} from '@/api/api'
export default {
  name: "up",
  props: {
    // 重新对外暴露visible，控制显示隐藏
    visible: {
      type: Boolean,
      default: false,
    },
    spuId: [String, Number],
    activeName: {
      type: String,
      default: 1,
    },
  },
  computed: {
    // 通过计算属性，对.sync进行转换，外部也可以直接使用visible.sync
    isVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      },
    },
    title() {
      return "账单导入";
    },
  },
  data() {
    return {
      loading: false,
      isVisibleImport: false,
      addForm: {
        dataType: 2,
      },
      rules: {},
      addForm: {},
      storeList: [],
      tableData: [],
      tableReload: true,
      onRemoveSpuIds: [],
      selectSpus: [],
      money: 0,
      requestParam: {},
      rules: {
        businessType: [{ required: true, message: "不能为空", trigger: "change" }],
        modelFlag: [{ required: true, message: "不能为空", trigger: "change" }],
      },
      headers: {
        Authorization: getToken(),
      },
      fileList: [],
      fileList2: [],
      fileListAll: [],
      fjLoading: false,
      errorType: false,
      disabled: false,
      modelList: [],
    };
  },
  mounted() {
  },
  methods: {
    onCancel() {
      this.isVisible = false;
    },
    confirm() {
      this.$refs.ruleForm.validate((valid) => {
        if (!valid) return;
      });
    },

    handleRemove(file, fileList) {
      if (this.errorType) {
        this.fileList = [];
        return;
      }
      this.fileList = fileList;
      console.log(file, fileList);
    },
    httpRequest(file) {},
    handleSuccess(res, file) {
      if (res.code === 200) {
        this.$message.success(res.message);
      } else {
        this.$message.error(res.message);
      }
      this.onCancel();
    },
    // 验证
    beforeUpload(file) {
      // console.log(file);
      // console.log(this.fileList);
      let pattern = file.name.substring(file.name.lastIndexOf(".") + 1).toLowerCase();
      let accept = '.xls,.xlsx'
      if (!accept.includes(pattern)) {
        this.errorType = true;
        this.$message.error("只能上传xls、xlsx，格式文件!");
        return false;
      }
        this.fileList.push(file);
    },
    checkFormValid(file) {
      this.$refs["requestParam"].validate((valid) => {
        if (valid) {
          this.submitUpload(file);
        } else {
          this.$message.error("参数校验失败！");
        }
      });
    },
    handleRemove2(file, fileList) {
      if (this.errorType) {
        this.fileList2 = [];
        return;
      }
      this.fileList2 = fileList;
    },
    // 验证
    beforeUpload2(file) {
      // console.log(file);
      // console.log(this.fileList);
      let pattern = file.name.substring(file.name.lastIndexOf(".") + 1).toLowerCase();
      let accept = '.xls,.xlsx'
      if (!accept.includes(pattern)) {
        this.errorType = true;
        this.$message.error("只能上传xls、xlsx，格式文件!");
        return false;
      }
        this.fileList2.push(file);
    },
    checkFormValid(file) {
      this.$refs["requestParam"].validate((valid) => {
        if (valid) {
          this.submitUpload(file);
        } else {
          this.$message.error("参数校验失败！");
        }
      });
    },
    async submitUpload() {
      if (!this.fileList.length || !this.fileList2.length) {
        this.$message.error("请确认所有文件是否上传完毕");
        return;
      }
      const loading = this.$loading({
        lock: true,
        text: '文件导入中...',
        spinner: 'el-icon-loading'
      });
      const extData = {
        reportName: 'importTransactionRecord',
        appCode: SUB_APP_CODE,
        paramMap: [],
      };
      let res = await this.$api.common.importFile(this.fileList[0], extData)
      extData.reportName = 'importFundRecord'
      let res2 = await this.$api.common.importFile(this.fileList2[0], extData)
      if(res.success && res2.success) {
        this.$notify.success({
          title: '成功',
          message: '导入数据成功'
        });
        this.onCancel()
        this.$emit('success')
      }else{
        this.$message.error('导入数据失败，请重新导入！');
      }
      loading.close();
    },
  },
};
</script>

<style lang="stylus" scoped>
>>> .el-form--label-top .el-form-item__label {
  padding: 0
}
</style>
